export default __webpack_public_path__ + "static/media/caseSuperBond.8bd76e53.png";